import { useAccount, useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Tooltip } from '@bst/react-ui';
import useProfileMenu from "../Hooks/useProfileMenu";
import { MENU_ITEM } from '../Hooks/useNavBar';

export interface Props {
  /**
   * Optional handle logout
   */
  handleLogout: () => void;
  setActiveMenu: (value: MENU_ITEM) => void;
}

/**
 *  Profile menu options
 * @param handleLogout - function to handle the logging a user out
 * @returns
 */
const ProfileMenu = ({ setActiveMenu, handleLogout }: Props) => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const {
    showUserManagement,
    UserInformation,
    showInsightAppSettings,
  } = useProfileMenu();
  const { t } = useTranslation();
  const [dataLetters, setDataLetters] = useState("");
  const [show, setShow] = useState(false);

  useEffect(() => {
    let splitLetter: string = " ";

    if (account && account.name) {
      const splitName = account.name.split(" ");
      splitLetter = splitName.map((item) => item.charAt(0)).join("");
    }

    const letters: string = UserInformation.initials
      ? UserInformation.initials
      : splitLetter;

    setDataLetters(letters);
  }, [UserInformation.initials, account]);

  return (
    <div className="global-utilities__item u-hide-sm-down">
      <Dropdown
        show={show}
        onToggle={() => setShow(!show)}
        align="end"
        className="global-utilities__item  dropdown-profile-menu-icon"
      >
        <Tooltip content={t("userProfile")}>
          <Dropdown.Toggle
            className={`button__utility global-utilities__button ${show ? "is-active" : ""
              }`}
            name="dropdown"
            data-testid="user-profile-toggle"
            id="dropdown-basic"
            aria-label="views"
            onClick={() => setShow(!show)}
          >
            <span
              className="global-utilities__button__icon"
              aria-hidden="true"
              data-testid="user-profile"
            >
              <i className="icon icon-profile"></i>
            </span>
          </Dropdown.Toggle>
        </Tooltip>
        <Dropdown.Menu className="dropdown--user dropdown">
          <Dropdown.Header className="dropdown__header">
            <span
              className="dropdown__user-initials"
              data-letters={dataLetters}
            />
            <div className="dropdown__name-wrap">
              <h1 className="dropdown__name" data-testid="user-name">
                {UserInformation.userName}
              </h1>
              <h2 className="dropdown__title" data-testid="user-title">
                {UserInformation.title}
              </h2>
            </div>
          </Dropdown.Header>
          <div className="dropdown-profile-menu-wrapper dropdown__items-wrap">
            <Dropdown.Item
              eventKey="2"
              className="dropdown__item"
              data-testid="My Settings"
              onClick={() => setActiveMenu(MENU_ITEM.MY_SETTINGS)}
            >
              <span
                className="dropdown__item__icon"
                aria-hidden="true"
                title="My Settings"
              >
                <i className="icon icon-settings"></i>
              </span>
              <span className="dropdown__item__label">{t("mySettings.title")}</span>
            </Dropdown.Item>
            {showInsightAppSettings && (
              <Dropdown.Item
                eventKey="3"
                className="dropdown__item u-hide-md-down"
                data-testid="Insight App Settings"
                onClick={() => setActiveMenu(MENU_ITEM.APP_SETTINGS)}
              >
                <span
                  className="dropdown__item__icon"
                  aria-hidden="true"
                  title="Insight App Settings"
                >
                  <i className="icon icon-appsettings"></i>
                </span>
                <span className="dropdown__item__label">
                  {t("appSettings")}
                </span>
              </Dropdown.Item>
            )}
            {showUserManagement && (
              <Dropdown.Item
                eventKey="4"
                className="dropdown__item u-hide-md-down"
                data-testid="user-profile-button_user_management"
                onClick={() => setActiveMenu(MENU_ITEM.USER_MANAGEMENT)}
              >
                <span
                  className="dropdown__item__icon"
                  aria-hidden="true"
                  title="User Management"
                >
                  <i className="icon icon-usersettings"></i>
                </span>
                <span className="dropdown__item__label">
                  {t("userManagement")}
                </span>
              </Dropdown.Item>
            )}
            <Dropdown.Item
              eventKey="5"
              className="dropdown__item"
              onClick={() => {
                window.open(
                  "https://insightssupport.bstglobal.com/help/Default.htm ",
                  "_blank",
                  "noopener"
                );
              }}
            >
              <span
                className="dropdown__item__icon"
                aria-hidden="true"
                title="Help"
              >
                <i className="icon icon-help"></i>
              </span>
              <span className="dropdown__item__label">{t("help")}</span>
            </Dropdown.Item>
            <Dropdown.Item
              eventKey="6"
              className="dropdown__item"
              data-testid="user-profile-button_log-out"
              onClick={() => handleLogout()}
            >
              <span
                className="dropdown__item__icon"
                aria-hidden="true"
                title="Logout"
              >
                <i className="icon icon-logout"></i>
              </span>
              <span className="dropdown__item__label">{t("logout")}</span>
            </Dropdown.Item>
          </div>
        </Dropdown.Menu>
      </Dropdown>
      {show && <div className="user-profile-overlay"></div>}
    </div>
  );
};

export default ProfileMenu;
